var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 19,
    viewBox: "0 0 27 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0368 10.0035L11.566 13.205C11.3121 13.3416 10.4502 13.1578 10.4502 12.8695V6.29853C10.4502 6.00671 11.3192 5.8229 11.5731 5.96738L17.7672 9.33693C18.0268 9.48498 18.2993 9.86121 18.0368 10.0035ZM26.5219 6.14262C26.5219 3.02627 23.9956 0.5 20.8793 0.5H6.44979C3.33344 0.5 0.807892 3.02627 0.807892 6.14262V12.8574C0.807892 15.9744 3.33344 18.5 6.44979 18.5H20.8793C23.9956 18.5 26.5219 15.9744 26.5219 12.8574V6.14262Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.df2fbc5e2d7b418dac7631e8599899db.svg";
export { ForwardRef as ReactComponent };